export const answerTypes = {
    Sales: 'sales',
    Analytics: 'analyst',
    Marketing: 'marketing',
    Production: 'prod',
    Logic: 'log',
    HR: 'hr'
};
